import themed from '@/ui/Theme/themed'
import Modal from './Modal'

const themedModal = themed(Modal)

export { themedModal as Modal }
export default Modal



// WEBPACK FOOTER //
// ./ui/Modal/index.js